module.exports = __webpack_public_path__ + "static/media/shape0_6.0d237c62.obj";